module.exports = {"id":"206316","name":"Tal Ben Haim","rating":"74","photo":"./data/images/photos/0/206316.png","club":{"name":"Sparta Prague","logo":"./data/images/clubs/SpartaPrague.png"},"positions":["AG","AD","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TalBenHaim0.json
// module id = 4071
// module chunks = 0